export const passwordHint = (e) => {
    const field = e.target;
    if (field.validity.patternMismatch) {
        field.setCustomValidity(
            'Password must be at least 8 characters long and include uppercase & lowercase letters, a number, and a symbol.'
        );
    } else {
        field.setCustomValidity('');
    }
}